import React, {useEffect, useState} from "react";
import AdminSideMenu from "./AdminSideMenu";
import firebase from "firebase";
import {CreateFileNameOptions} from "../../helpers/CreateFileNameOptions";
import _ from 'lodash'
import axios from "axios";
import fileDownload from "js-file-download";
import {storage} from "../../firebase";

function AdminSideMenuWrapper(
    {
        handleSideMenu,
        databaseChoice,
        handleSetDatabaseChoice,
        handleSetAction,
        actionChoice,
        mediaChoice,
        handleSetMediaChoice,
        classLevel,
        handleClassLevel,
        assignment,
        handleSetAssignment,
        handleEditAssignment,
        setAssignment,
        editAssignmentLoading,
        editAssignmentProgress,
        editAssignment,
        handleStatisticChoice,
        statisticChoice
    }
) {

    const [fileNames, setFileNames] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showDirections, setShowDirections] = useState(false);

    useEffect(() => {
        let tmpFileNames = [];

        async function fetchData() {
            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice).listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        tmpFileNames.push(folderRef.location.path_.split('/')[3])
                    })
                }).catch(e => console.log(e));
            setFileNames(CreateFileNameOptions(tmpFileNames))
        }

        async function fetchDialogAssignments() {
            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        tmpFileNames.push(folderRef.location.path_.split('/')[4])
                    })
                }).catch(e => console.log(e));
            setFileNames(CreateFileNameOptions(tmpFileNames))
        }

        async function fetchDataForStatistics() {
            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + statisticChoice).listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        tmpFileNames.push(folderRef.location.path_.split('/')[3])
                    })
                }).catch(e => console.log(e));
            setFileNames(CreateFileNameOptions(tmpFileNames))
        }

        async function fetchDialogAssignmentsForStatistics() {
            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + statisticChoice + '/assignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        tmpFileNames.push(folderRef.location.path_.split('/')[4])
                    })
                }).catch(e => console.log(e));
            setFileNames(CreateFileNameOptions(tmpFileNames))
        }

        if (databaseChoice !== 'statistics' || databaseChoice !== 'dialogAssignments') {
            fetchData().then(() => console.log('ready')).catch(e => console.log(e))
        }
        if (databaseChoice === 'dialogAssignments') {
            fetchDialogAssignments().then(() => console.log('ready')).catch(e => console.log(e))
        }

        if(statisticChoice !== 'statistics' && statisticChoice !== 'dialogAssignments'){
            fetchDataForStatistics().then(r => console.log(r))
        }
        if(statisticChoice === 'dialogAssignments'){
            fetchDialogAssignmentsForStatistics().then(r => console.log(r))
        }

    }, [classLevel, actionChoice, databaseChoice, assignment, statisticChoice]);

    useEffect(() => {
        setDeleteMsg('')
    }, [classLevel, actionChoice, databaseChoice, assignment])

    const handleDeleteModal = () => {
        setDeleteModal(!deleteModal)
    };

    const handleDeleteAssignment = () => {
        async function deleteAssignment() {
            setLoading(true)
            let tmpFileNames = [];

            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice).listAll()
                .then((data) => {
                    for (let i = 0; i < data.items.length; i++) {
                        tmpFileNames.push('assignment' + (i + 1) + '.json')
                    }
                }).catch(e => console.log(e));

            for (let i = 0; i < tmpFileNames.length; i++) {

                if (tmpFileNames[i] === assignment) {
                    if (databaseChoice === 'quizAssignments') {
                        const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                        studentFile.getDownloadURL()
                            .then(async url => await axios.get(url))
                            .then(res => {
                                    let studentData = res.data;
                                    for (let g = 0; g < studentData.length; g++) {
                                        studentData[g].assignmentNum.splice(i, 1);
                                        studentData[g].assignmentCompletion.splice(i, 1)
                                        for (let n = i; n < studentData[g].assignmentNum.length; n++) {
                                            studentData[g].assignmentNum[n] = n;
                                        }
                                    }

                                    const JSONobj = JSON.stringify(studentData);
                                    const blobObj = new Blob([JSONobj], {type: "application/json"});
                                    const uploadTask = storage.ref('students/10' + classLevel + '/quizData.json').put(blobObj);
                                    uploadTask.on(
                                        "state_changed",
                                        () => {
                                        },
                                        error => {
                                            console.log(error)
                                        },
                                        () => {
                                            storage
                                                .ref("students/10" + classLevel)
                                                .child('quizData.json')
                                                .getDownloadURL()
                                                .then(url => {
                                                        console.log(url);
                                                    }
                                                )
                                                .catch(e => console.log(e));
                                        }
                                    )
                                }
                            );
                    }
                    const refToDelete = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/' + assignment);
                    await refToDelete.delete().then(() => console.log('deleting in progress')).catch(() => setDeleteMsg('An error has occurred'))

                    for (let w = i + 1; w < tmpFileNames.length; w++) {

                        const assignmentToReplaceRef = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/' + tmpFileNames[w]);
                        await assignmentToReplaceRef.getDownloadURL()
                            .then(async (url) => {
                                await axios.get(url, {
                                    responseType: 'blob',
                                })
                                    .then(async (res) => {
                                        const uploadTask = storage.ref('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/' + tmpFileNames[w - 1]).put(res.data);
                                        await uploadTask.on(
                                            "state_changed",
                                            () => {
                                            },
                                            error => {
                                                console.log(error)
                                            },
                                            () => {
                                                storage
                                                    .ref("assignments/Samoan10" + classLevel + "/" + databaseChoice)
                                                    .child(tmpFileNames[w - 1])
                                                    .getDownloadURL()
                                                    .then(url => {
                                                            setDeleteMsg(assignment + ' has been successfully deleted');
                                                            setProgress(prevState => prevState + (Math.round(100 / tmpFileNames.length)))
                                                        }
                                                    )
                                                    .catch(e => console.log(e));
                                            }
                                        )
                                    })
                            });


                    }

                    const lastRefToDelete = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/' + tmpFileNames[tmpFileNames.length - 1]);
                    await lastRefToDelete.delete().then(() => setDeleteMsg(prevState => assignment + ' has been successfully deleted')).catch(() => setDeleteMsg('An error has occurred'))

                    break;
                }
            }
        }

        async function deleteDialogAssignment() {
            setLoading(true)
            let tmpFileNames = [];
            await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments/').listAll()
                .then((data) => {
                    for (let i = 0; i < data.items.length; i++) {
                        tmpFileNames.push('assignment' + (i + 1) + '.json')
                    }
                }).catch(e => console.log(e));

            for (let i = 0; i < tmpFileNames.length; i++) {

                if (tmpFileNames[i] === assignment) {

                    const refToDelete = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments/' + assignment);
                    await refToDelete.delete().then(() => console.log('Deleting in progress')).catch(() => setDeleteMsg('An error has occurred'))

                    for (let w = i + 1; w < tmpFileNames.length; w++) {

                        const assignmentToReplaceRef = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments/' + tmpFileNames[w]);
                        await assignmentToReplaceRef.getDownloadURL()
                            .then(async (url) => {
                                await axios.get(url, {
                                    responseType: 'blob',
                                })
                                    .then(async (res) => {
                                        const uploadTask = storage.ref('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments/' + tmpFileNames[w - 1]).put(res.data);
                                        await uploadTask.on(
                                            "state_changed",
                                            () => {
                                            },
                                            error => {
                                                console.log(error)
                                            },
                                            () => {
                                                storage
                                                    .ref('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments')
                                                    .child(tmpFileNames[w - 1])
                                                    .getDownloadURL()
                                                    .then(url => {
                                                            setDeleteMsg(assignment + ' has been successfully deleted');
                                                            setProgress(prevState => prevState + (Math.round(100 / tmpFileNames.length)))
                                                        }
                                                    )
                                                    .catch(e => console.log(e));
                                            }
                                        )
                                    })
                            });

                    }
                    const lastRefToDelete = await firebase.storage().ref().child('/assignments/Samoan10' + classLevel + '/' + databaseChoice + '/assignments/' + tmpFileNames[tmpFileNames.length - 1]);
                    await lastRefToDelete.delete().then(() => setDeleteMsg(prevState => 'Deleting in progress')).catch(() => setDeleteMsg('An error has occurred'));
                    break;
                }
            }

        }

        if (databaseChoice !== 'dialogAssignments') {
            deleteAssignment().then(() => {

                setAssignment('');
                setLoading(false);
                setProgress(0);
            }).catch(e => console.log(e))
        } else if (databaseChoice === 'dialogAssignments') {
            deleteDialogAssignment().then(() => {
                setAssignment('');
                setLoading(false);
                setProgress(0);
            }).catch(e => console.log(e))
        }

    };

    const handleShowDirections = () => {
        setShowDirections(prevState => !prevState)
    }

    return (
        <>
            <AdminSideMenu
                handleSideMenu={handleSideMenu}
                databaseChoice={databaseChoice}
                handleSetDatabaseChoice={handleSetDatabaseChoice}
                handleSetAction={handleSetAction}
                actionChoice={actionChoice}
                mediaChoice={mediaChoice}
                handleSetMediaChoice={handleSetMediaChoice}
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
                fileNames={fileNames}
                assignment={assignment}
                handleSetAssignment={handleSetAssignment}
                deleteModal={deleteModal}
                handleDeleteModal={handleDeleteModal}
                handleDeleteAssignment={handleDeleteAssignment}
                deleteMsg={deleteMsg}
                handleEditAssignment={handleEditAssignment}
                loading={loading}
                progress={progress}
                editAssignmentLoading={editAssignmentLoading}
                editAssignmentProgress={editAssignmentProgress}
                editAssignment={editAssignment}
                statisticChoice={statisticChoice}
                handleStatisticChoice={handleStatisticChoice}
                handleShowDirections={handleShowDirections}
                showDirections={showDirections}
            />
        </>
    )
}

export default AdminSideMenuWrapper
